import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import { getFormValues } from 'redux-form';
import { ORDER_IMPORT_FORM_NAME } from './constants';
import { initialState } from './reducer';

export const selectImportedOrdersModalDomain = state => state.ordersImportsModalReducer || initialState;
export const selectRouterDomain = state => state.router || {};
export const getIsImportedFileLoadingSelector = () =>
	createSelector(selectImportedOrdersModalDomain, ({ isImportFileLoading }) => isImportFileLoading);

export const getIsOrderImportFormOpenSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'order' && query?.mode === 'import');
	});

export const getDataForImportSelector = () =>
	createSelector(getFormValues(ORDER_IMPORT_FORM_NAME), formValues => {
		if (!formValues) return {};
		return {
			file: formValues.file,
		};
	});
